import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { BaseService, EnvironmentService, ResponseResult } from 'tnx-shared';

@Injectable({
    providedIn: 'root'
})
export class WorkflowDefineService extends BaseService {
    entityName = 'WorkflowDefine';
    serviceCode = 'admin';

    constructor(http: HttpClient, injector: Injector,
        private _environmentService: EnvironmentService) {
        super(http, injector, ``);
        this.endPoint = _environmentService.getHttpServiceEndpointWithVersion(this.serviceCode);
        this.serviceUri = `${this.endPoint}/${this.entityName}`;
    }

    createWfDefinition(xml: string): Promise<ResponseResult> {
        const apiUrl = `${this.serviceUri}/createWorkflowDefinition`;

        const obj = {
            processXml: xml
        };

        return this._http.post<ResponseResult>(apiUrl, obj)
            .pipe(
                catchError((err: HttpErrorResponse) => this.handleError(err, this._injector))
            ).toPromise();
    }

    loadDefaultBpmn(): Promise<string> {
        const url = '../assets/bpmn/initial.bpmn';
        return this._http
            .get(url, {
                headers: { observe: 'response' },
                responseType: 'text'
            }).toPromise();
    }

    delete(id: number): Promise<ResponseResult> {
        const url = `${this.serviceUri}/Delete/${id}`;
        return this._http.delete<ResponseResult>(url).toPromise();
    }

    getDetail(id): Promise<ResponseResult> {
        const url = `${this.serviceUri}/GetById/${id}`;
        return this._http.get<ResponseResult>(url).toPromise();
    }

    deleteMany(lstId: string) {
        const url = `${this.serviceUri}/DeleteManyCustomAsync/${lstId}`;
        return this._http.delete<ResponseResult>(url).toPromise();
    }
}
